const { ASSETS_PATH } = process.env;

export default {
  telemedicine: {
    calling: `${ASSETS_PATH}sounds/telemedicine-calling.wav`,
  },
};
